/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { ElectronicStatementsDownloadModelDto, ReportInformationModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class ElectronicdocumentsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags ElectronicStatements
   * @name ElectronicStatementsDownloadElectronicDocument
   * @summary Downloads an electronic document (PDF) for the given report identifier.
   * @request POST:/electronicdocuments/download
   */
  electronicStatementsDownloadElectronicDocument = (
    data: ElectronicStatementsDownloadModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<File, string>({
      path: `/electronicdocuments/download`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ElectronicStatements
   * @name ElectronicStatementsGetElectronicDocumentList
   * @summary Retrieves the list of available electronic documents (reports) for a product/account.
   * @request GET:/electronicdocuments/{productName}/reportlist/{accountId}
   */
  electronicStatementsGetElectronicDocumentList = (
    productName: string,
    accountId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<ReportInformationModelDto[], string>({
      path: `/electronicdocuments/${productName}/reportlist/${accountId}`,
      method: "GET",
      format: "json",
      ...params,
    });
}
